module.exports = __webpack_public_path__ + "img/s.bb851da2.jpg";